var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"list-item-icon"},[_c('b-icon',{attrs:{"icon":"horseshoe"}})],1),_c('div',{staticClass:"list-item-content"},[_c('p',[_c('strong',[_vm._v(_vm._s(_vm.horse.name))]),_c('br'),_vm._v("\n      Caballo\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }